import {configureStore} from '@reduxjs/toolkit';
import {useDispatch, useSelector} from 'react-redux';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {commonSliceReducer} from '@/store/slices/commonSlice';
import themeReducer from './slices/themeSlice';
import countryCodeReducer from './slices/countryCodeSlice';
import {salesTargetSliceReducer} from '@/store/slices/salesTargetSlice';
import {activitySliceReducer} from '@/store/slices/activitySlice';
import {pointMultiplierSliceReducer} from '@/store/slices/pointMultiplier';
import {bulkModifiersSliceReducer} from '@/store/slices/bulkPointSlice';
import {userDetailsSliceReducer} from '@/store/slices/userSlice';
import {productReviewSliceReducer} from '@/store/slices/productReviewSlice';
import rewardsReducer from '@/store/slices/rewardsSlice';
import rewardBulkUploadReducer from '@/store/slices/rewardBulkUpload';

const createPersistedReducer = (key, reducer) =>
  persistReducer({key, storage, whitelist: [key]}, reducer);

const persistedActivityReducer = createPersistedReducer(
  'activity',
  activitySliceReducer
);
const persistedPointMultiplierReducer = createPersistedReducer(
  'pointMultiplier',
  pointMultiplierSliceReducer
);
const persistedSalesTargetReducer = createPersistedReducer(
  'salesTarget',
  salesTargetSliceReducer
);
const persistedProductReviewReducer = createPersistedReducer(
  'productReview',
  productReviewSliceReducer
);

export const reducers = {
  common: commonSliceReducer,
  theme: themeReducer,
  countryCode: countryCodeReducer,
  salesTarget: persistedSalesTargetReducer,
  activity: persistedActivityReducer,
  bulkModifiers: bulkModifiersSliceReducer,
  userDetails: userDetailsSliceReducer,
  productReview: persistedProductReviewReducer,
  pointMultiplier: persistedPointMultiplierReducer,
  rewards: rewardsReducer,
  rewardBulkUpload: rewardBulkUploadReducer
};

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'] // Ignore persist actions
      }
    })
});

export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;
export const persistor = persistStore(store);
